import Api from "../config/api";

export const findAllTag = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($search: String, $pageableDTO: PageableDTOInput, $ativo: Boolean) {
        findAllTag(search: $search, pageableDTO: $pageableDTO, ativo: $ativo) {
          last
          content {
            id
            nome
            cor
            ativo
          }
        }
      }
    `,
    variables,
  });

  if (response.data.errors) {
    throw Error("Erro ao carregar as tags.");
  }
  return response.data.data.findAllTag;
};

export const findByIdTag = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($id: UUID) {
        findByIdTag(id: $id) {
          id
          nome
          cor
          ativo
        }
      }
    `,
    variables,
  });

  if (response.data.errors) {
    throw Error("Erro ao carregar a tag.");
  }
  return response.data.data.findByIdTag;
};

export const saveTag = async (tag) => {
  const method = tag.id ? "updateTag" : "createTag";
  const response = await Api.post("", {
    query: `
      mutation($tag: TagInput) {
        ${method}(tag: $tag) {
          id
          nome
          cor
          ativo
        }
      }
    `,
    variables: { tag },
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message);
  }
  return response.data.data[method];
};

export const ativarTag = async (id) => {
  const response = await Api.post("", {
    query: `
      mutation($id: Long) {
        ativarTag(id: $id) {
          id
          ativo
        }
      }
    `,
    variables: { id },
  });

  if (response.data.errors) {
    throw Error("Erro ao ativar a tag.");
  }
  return response.data.data.ativarTag;
};

export const inativarTag = async (id) => {
  const response = await Api.post("", {
    query: `
      mutation($id: Long) {
        inativarTag(id: $id) {
          id
          ativo
        }
      }
    `,
    variables: { id },
  });

  if (response.data.errors) {
    throw Error("Erro ao inativar a tag.");
  }
  return response.data.data.inativarTag;
};